import React from "react";
import { useOptionalAuth0 } from "../hooks/useOptionalAuth0";

interface ProtectedRouteProps {
  component: React.ComponentType<any>;
  [key: string]: any;
}

const ProtectedRoute = ({ component: Component, ...props }: ProtectedRouteProps) => {
  const { isAuthenticated, isLoading, loginWithRedirect } = useOptionalAuth0();

  if (isLoading) {
    return <div>Loading...</div>; // or spinner
  }

  if (!isAuthenticated) {
    loginWithRedirect();
    return null; // Don't render anything while redirecting
  }

  return <Component {...props} />;
};

export default ProtectedRoute;
